import { SxProps } from '@mui/material'

interface AccordionStyles {
  accordionStyles: SxProps
}

export const accordionStyles: AccordionStyles = {
  accordionStyles: {
    '&.Mui-expanded': {
      margin: 0,
    },
  },
}
